import {
  LoadAssessmentResults,
  LoadAssessmentResultsComplete,
  LoadQuestionDetails,
  LoadQuestionDetailsComplete } from './assessment-results-load.action';

export enum AssessmentResultsActionType {

  LoadAssessmentResults           = 'LOAD_ASSESSMENT_RESULTS',
  LoadAssessmentResultsComplete   = 'LOAD_ASSESSMENT_RESULTS_COMPLETE',

  LoadQuestionDetails             = 'LOAD_QUESTION_DETAILS',
  LoadQuestionDetailsComplete     = 'LOAD_QUESTION_DETAILS_COMPLETE',
}

export type AssessmentResultActions =

LoadAssessmentResults |
LoadAssessmentResultsComplete |
LoadQuestionDetails |
LoadQuestionDetailsComplete;
